<template>
  <div class="Input">
    <div class="control">
      <label :class="[{ floatingLabel: floatingLabel }, { active: active }]">{{ label }}</label>
      <SvgSearch @click="$emit('search')" />
      <input
        :readonly="readOnly"
        ref="input"
        class="input"
        :class="{ invalid: invalid }"
        :placeholder="placeholder"
        :type="type"
        v-bind="$attrs"
        :value="modelValue"
        @input="updateValue"
        @keyup.enter="$emit('search')"
      />
    </div>
  </div>
</template>

<script>
  import SvgSearch from '@/assets/img/ic_search.svg';

  export default {
    name: 'w-input-search',
    components: {
      SvgSearch,
    },
    props: {
      // value: [String, Number],
      label: String,
      placeholder: String,
      isFloatingLabel: Boolean,
      invalid: String,
      className: String,
      readOnly: {
        type: Boolean,
        default: false,
      },
      autoFocus: {
        type: Boolean,
        default: false,
      },
      bgColor: String,
      type: {
        type: String,
        default: 'text',
      },
      modelValue: {
        required: true,
      },
    },
    mounted() {
      if (this.autoFocus) {
        this.$refs.input.focus();
      }
      if (this.bgColor) {
        this.$refs.input.style.backgroundColor = this.bgColor;
      }
    },
    computed: {
      active() {
        if (typeof this.modelValue === 'number') {
          return this.isFloatingLabel && this.modelValue >= 0;
        }
        return this.isFloatingLabel && this.modelValue && this.modelValue.length > 0;
      },
      floatingLabel() {
        return this.isFloatingLabel && this.label && !this.placeholder;
      },
    },
    model: {
      event: 'update',
    },
    methods: {
      updateValue(event) {
        this.$emit('update:modelValue', event.target.value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';
  .Input {
    position: relative;
    .control {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border: 1px solid $background-3;
      background-color: $white;
      border-radius: 8px;
      height: 48px;
      padding: 4px 4px 4px 12px;
      svg {
        cursor: pointer;
      }
      .input {
        padding: 0 8px;
        width: 100%;
        // height: 56px;
        border: 0;
        font-size: 14px;
        margin: 0;
        box-shadow: none;
        background-color: transparent;
        color: $text-title;
      }
      .searchText {
        width: 100%;
        margin-bottom: 0;
      }
    }
  }

  .floatingLabel {
    position: absolute;
    pointer-events: none;
    left: 18px;
    top: 18px;
    z-index: 2;
    color: $secondary-main;
    transition: 0.2s ease all;
  }

  input:focus ~ .floatingLabel,
  .active {
    top: 2px;
    bottom: 10px;
    left: 18px;
    font-size: 11px;
    opacity: 1;
  }

  .invalid {
    color: $error;
  }

  .filterBar {
    input {
      background: #f7f7f7;
    }
  }
  .inputVal {
    background: #f7f7f7;
    border-radius: 16px;
    .floatingLabel {
      top: 23px;
    }
    .input {
      background: #f7f7f7;
    }
  }
  .inputVal:focus ~ .floatingLabel,
  .active {
    top: 2px !important;
  }
</style>
